import { useEffect } from 'react'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'

export default function useNoPermission() {
  const navigate = useNavigate()
  const onNoPermission = (event) => {
    if (event.data === 'NoPermission') {
      toast.error('Not authorized to view this page')
      navigate('/not-authorized')
    }
  }
  useEffect(() => {
    window.addEventListener('message', onNoPermission, false)
    return () => {
      window.removeEventListener('message', onNoPermission, false)
    }
  }, [])
}
